export { default } from './BooleanIcon'
